import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import ActivationCodeModalButton from "../ActivationCodeModal/ActivationCodeModalButton";
import moment from "moment";
import Delete from "../../Core/Components/Buttons/Delete";

class LicensesInUseListRow extends Component {
  onDeleteLicenseInUse() {
    const result = window.confirm("Delete record?");
    if (result) {
      const { licenseInUse } = this.props;
      licenseInUse.store.deleteById(licenseInUse.Id);
    }
  }

  render() {
    const { stores, licenseInUse } = this.props;

    let userName = "";
    const user = stores.data.UsersStore.findById(licenseInUse.UserId);
    if (user) userName = user.Name;

    let applicationName = null;
    const license = stores.data.LicensesStore.findById(licenseInUse.LicenseId);
    if (license) {
      const application = stores.data.ApplicationsStore.findById(license.ApplicationId);
      if (application) applicationName = application.Name;
    }

    let deleteButton = null;
    if (stores.currentUser.user.isAdmin) {
      deleteButton = <Delete onClick={this.onDeleteLicenseInUse.bind(this)} />;
    }

    let activationCodeButton = "";
    if (licenseInUse.Offline) {
      if (user) activationCodeButton = <ActivationCodeModalButton userId={user.Id} />;
    }

    const reservationType = !licenseInUse.Offline ? "Online" : "Offline";

    return (
      <tr>
        <td>{applicationName}</td>
        <td>{userName}</td>
        <td>{moment(licenseInUse.StartDate).format("L LTS")}</td>
        <td>{moment(licenseInUse.EndDate).format("L LTS")}</td>
        <td>{reservationType}</td>
        <td>{activationCodeButton}</td>
        <td>{deleteButton}</td>
      </tr>
    );
  }
}
export default inject("stores")(observer(LicensesInUseListRow));



// WEBPACK FOOTER //
// ./src/Components/LicensesInUseList/LicensesInUseListRow.js